import { publishReplay, refCount } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable }     from '@angular/core';
import {HttpClientService} from '../httpClient/httpclient.service';
import {roleMS, roleMSDTO} from '../../models/roleMS.model';
import {UserApplication} from '../../models/user.model';
import {RolesService} from '../user/roles.service';
import { GrantRole } from 'app/views/administration/users/changeUsersRoleForm.component';

@Injectable()
export class RoleMSService{
  roleMap: Map<string, roleMSDTO[]>;
  roleMS: roleMS[];
  private cachedFields: Observable<any>;

  public baseUrlLoyalty = '/koncentro-loyalty';

  constructor(private h: HttpClientService, private srvRole: RolesService) {
    this.roleMap = new Map<string, roleMSDTO[]>();
    this.roleMS = [];
  }


  list(baseUrlLoyalty?: string){
    if(baseUrlLoyalty === null || baseUrlLoyalty === undefined){
      baseUrlLoyalty = this.baseUrlLoyalty;
    }
    return this.h.getPaged(baseUrlLoyalty + '/permissions/roles')
      .map(res => {
        return res;
      });
  }

  get(userApp: UserApplication) {
    return this.h.get(userApp.ms_base_url + "/permissions/roles")
      .map(res => {
        this.roleMap[userApp.ms_base_url] = res;
        return {userApp: userApp, list: res};
      },() => {
        return {userApp: userApp, list: []};
      });
  }
  post(role: roleMS) {
    return this.h.post(role.ms_base_url + "/permissions/roles", role)
      .map(res => {
        let currentRoles = this.roleMap[role.ms_base_url];
        currentRoles.push({
          id: role.id,
          description: role.description
        });
        this.roleMap.set(role.ms_base_url, currentRoles);

        role.id = res.id;
        this.roleMS.push(role);

      });
  }

  put(role: roleMS) {
    return this.h.put(role.ms_base_url + "/permissions/roles/" + role.id, role)
      .map(res => {
        let currentRoles = this.roleMap[role.ms_base_url];
        Object.assign(currentRoles.find(r => r.id == role.id), {id: role.id, description: role.description});
        this.roleMap.set(role.ms_base_url, currentRoles);

        Object.assign(this.roleMS.find(r => r.id == role.id), role);
      });
  }

  delete(role: roleMS) {
    return this.h.delete(role.ms_base_url + "/permissions/roles/" + role.id)
      .map(res => {
        let currentRoles = this.roleMap[role.ms_base_url];
        currentRoles.splice(currentRoles.findIndex(r => r.id == role.id), 1);
        this.roleMap.set(role.ms_base_url, currentRoles);

        this.roleMS.splice(this.roleMS.findIndex(r => r.id == role.id), 1);
      });
  }

  getAll(userApps: UserApplication[]) {
    let resolving = [];

    resolving.push(new Promise(resolve => {
      this.srvRole.getAll().subscribe( () => {
        let roleAuth: roleMS[] = [];
        this.srvRole.roles.forEach( r => {
          roleAuth.push({
            id : r.id,
            application: 'Auth',
            applicationId: null,
            ms_base_url: this.srvRole.base_url,
            description: r.descr
          });
        }, this);

        resolve({
          userApp: {
          application_name: 'Auth',
          ms_base_url: this.srvRole.base_url,
          application_id: null
        }, list: roleAuth});
      }, () => {
        resolve({
          userApp: {
            application_name: 'Auth',
            ms_base_url: this.srvRole.base_url,
            application_id: null
          }, list: []});
      })
    }));


    userApps.forEach(function(u){
      resolving.push(new Promise( (resolve ) => {
        this.get(u).subscribe((data) => {
          resolve(data);
        }, (data) => {
          resolve(data);
        })
      }));
    }, this);


    Promise.all(resolving).then((data) => {
      this.roleMS = [];
      data.forEach(function(d){
        d.list.forEach(function(l){

          this.roleMS.push({
            id: l.id,
            description: l.description,
            application: d.userApp.application_name,
            ms_base_url: d.userApp.ms_base_url,
            applicationId: d.userApp.application_id
          });
        }, this);
      }, this);
    });
  }
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-auth/schema/RoleDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  getRolesForUser(appBaseUrl: string, userId: number) {
    return this.h.get(`${appBaseUrl}/permissions/rolesforuser/${userId}`);
  }

  addRoleForUser(appBaseUrl: string, payload: {user_id: number, role_id: number}) {
    return this.h.post(`${appBaseUrl}/permissions/roleusers`, payload);
  }

  removeRoleForUser(appBaseUrl: string, roleId: number) {
    return this.h.delete(`${appBaseUrl}/permissions/roleusers/${roleId}`);
  }

  updateRoleForUser(appBaseUrl: string, payload: GrantRole) {
    return this.h.put(`${appBaseUrl}/permissions/roleusers`, payload);
  }
}




// WEBPACK FOOTER //
// ./src/app/services/utils/roleMS.service.ts